import React, { useState, useEffect } from 'react'

let COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN
let CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID
let POOL_ID = process.env.REACT_APP_COGNITO_POOL_ID
let REDIRECT_URI = process.env.REACT_APP_COGNITO_REDIRECT_URI
let GOOGLE_PROVIDER = 'Google'
let localRedirectionURL = ''

const ConfigLoader = () => {
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    const initializeCognitoConfig = () => {
      const origin = window.location.origin
      // console.log(origin)
      localRedirectionURL = window.location.search.startsWith(
        '?redirect_to=' +
          origin +
          '/onboarding-full?onboardingStep=pickYourPath'
      )
        ? '?redirect_to=' +
          origin +
          '/onboarding-full?onboardingStep=pickYourPath'
        : '?redirect_to=' + origin + '/dashboard'
      REDIRECT_URI = origin + '/callback' + localRedirectionURL

      setIsReady(true)
    }

    if (document.readyState === 'complete') {
      initializeCognitoConfig()
    } else {
      window.addEventListener('load', initializeCognitoConfig)
      return () => window.removeEventListener('load', initializeCognitoConfig)
    }
  }, [])

  if (!isReady) return null

  return null // This component doesn't render anything visible
}

export default ConfigLoader

// Export the variables
export { COGNITO_DOMAIN, CLIENT_ID, POOL_ID, REDIRECT_URI, GOOGLE_PROVIDER }
